module.exports = __webpack_public_path__ + "static/media/loupe_icon.4b8be5c0.svg";